import { render, staticRenderFns } from "./WuzihuikudiaopeiByIdTable.vue?vue&type=template&id=4ba8f9e2&"
import script from "./WuzihuikudiaopeiByIdTable.vue?vue&type=script&lang=js&"
export * from "./WuzihuikudiaopeiByIdTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports